import artifact from '$houdini/artifacts/CreateUserAccount'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateUserAccountStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
